import * as React from "react";
import {cx} from "emotion";

import "./tooltip.scss";

import {cs}           from "@Common/react/chain-services";
import {Subscription} from "@Common/react/subscription";
import {UseRef}       from "@Common/react/use-ref";
import {UseState}     from "@Common/react/use-state";

export const Tooltip = ({message, next}) => cs(
    ["targetRef", (_, next) => UseRef({next})],
    ["state", (_, next) => UseState({next})],
    ({targetRef, state}) => <>
        {next({
            targetRef: targetRef.set,
            control: (() => {

                const activate = () => {
                    if (state.value) {
                        return;
                    }
                    // console.log(targetRef.get().getBoundingClientRect())
                    state.onChange({
                        target: targetRef.get().getBoundingClientRect(),
                    });
                };
                return {
                    onMouseEnter: activate,
                    onClick: activate,
                    onMouseLeave: () => {
                        if (state.value) {
                            // console.log("Leaved");
                            state.onChange(null);
                        }
                    },
                };
            })(),
        })}

        {/*{console.log(!!state.value)}*/}

        {state.value && <>
            {Subscription({
                init: () => {
                    const wheelListener = () => {
                        // console.log("Wheeled");
                        state.onChange(null);
                    };
                    window.addEventListener("mousewheel", wheelListener);
                    window.addEventListener("scroll", wheelListener);

                    return () => {
                        window.removeEventListener("mousewheel", wheelListener);
                        window.removeEventListener("scroll", wheelListener);
                    };
                },
            })}

            {(() => {
                const windowWidth = window.innerWidth;
                const horPos = getHorPos(state.value.target, windowWidth);
                const windowHeight = window.innerHeight;
                const verPos = getVerPos(state.value.target, windowHeight);

                // console.log("horPos", horPos);
                // console.log("verPos", verPos);
                if (!horPos || !verPos) {
                    return null;
                }

                // console.log({
                //     windowWidth,
                //     x: state.value.target.x,
                // })
                return (
                    <div
                        className={cx("tooltip-32z", `${horPos}-${verPos}`)}
                        style={{

                            ...horPos === "right" ? {
                                left: state.value.target.x + state.value.target.width
                            } : {
                                left: state.value.target.x
                            },

                            ...verPos === "bottom" ? {
                                top: state.value.target.y,
                            } : {
                                bottom: windowHeight - (state.value.target.y + state.value.target.height)
                            },
                        }}
                    >
                        <div className="message">
                            {message}
                        </div>

                        <i className={cx("fa", horPos === "right" ? "fa-caret-left" : "fa-caret-right")}/>
                    </div>
                );
            })()}
        </>}
    </>,
);

const minWidth = 250;
const distance = 15;

// right/left/null
const getHorPos = (rect, totalWidth) => {
    if (totalWidth - (rect.x + rect.width) > minWidth + distance) {
        return "right";
    }
    if (rect.x > minWidth + distance) {
        return "left";
    }
    return null;
};

// bottom/top/null
const getVerPos = (rect, totalHeight) => {
    if (totalHeight - (rect.y + rect.height) > distance) {
        return "bottom";
    }
    if (rect.y > minWidth + distance) {
        return "top";
    }
    return null;
};